export default __webpack_public_path__ + "static/media/3.cbb746a6.jpg";